<template>
  <div>
    <dictionary-modal-table
      dictionary_link="/packagings"
      title="Lista opakownań"
      :numeral_text="['opakowanie', 'opakowania', 'opakowań']"
      :columns_title="['name']"
    ></dictionary-modal-table>
  </div>
</template>

<script>
import DictionaryModalTable from "./DictionaryModalTable.vue";
export default {
  components: {
    DictionaryModalTable,
  },
};
</script>
